module["exports"] = ["S.A.", "LTDA", "EIRELI", "e Associados", "Comércio"];